<template>
  <div>
    <StartWorkCheckList
      v-model="startWorkCheckStore.checkTasks"
      :index="0"
      :title="t(useTranslationPath(callerPath, 'induction'))"
      :list
      type="radio"
      :action-label="t(useTranslationPath(callerPath, 'continue'))"
      @action-click="goBack"
    />
  </div>
</template>

<script setup>
import StartWorkCheckList from '@/components/WorkOrder/StartWorkCheck/StartWorkCheckList.vue'
import { useGoBack } from '@/composables/useGoBack.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useStartWorkCheckStore } from '@/stores/authenticated/StartWorkCheckStore.js'
import { useWorkOrderStore } from '@/stores/authenticated/WorkOrderStore'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()
const { setCustomGoBack } = useGoBack()

const appStore = useAppStore()
const workOrderStore = useWorkOrderStore()
const startWorkCheckStore = useStartWorkCheckStore()

const callerPath = 'views.authenticated.workOrders.startWorkChecks.induction'

const list = computed(() => {
  return startWorkCheckStore.checkTasks.at(0)?.tasks
})

onMounted(async () => {
  setCustomGoBack(goBack)

  appStore.$patch({ showBackButton: true })
})

const goBack = () => {
  router.push({
    name: `work-order.start-work-checks.index`,
    params: {
      workOrderId: workOrderStore.workOrder.id,
    },
  })
}
</script>
